import { AuthViewModel } from "../viewmodels/AuthViewModel.js";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AuthWrapper2/hooks/useCurrentOrganization.ts
function useCurrentOrganization() {
	return useSingleton(AuthViewModel).state.identityInfo.organization;
}
//#endregion
export { useCurrentOrganization };

//# sourceMappingURL=useCurrentOrganization.js.map